import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomCurrencyPipe } from '../custom-currency.pipe';
import { FileNamePipe } from '../file-name.pipe';
import { FujiBillingSidebarComponent } from './fuji-billing-sidebar/fuji-billing-sidebar.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FujiBillingFooterComponent } from './fuji-billing-footer/fuji-billing-footer.component';
import { ArabicDigitsPipe } from '../arabic-digits.pipe';



@NgModule({
  declarations: [
    CustomCurrencyPipe,
    FileNamePipe,
    FujiBillingSidebarComponent,
    FujiBillingFooterComponent,
    ArabicDigitsPipe
  ],
  exports: [
    FileNamePipe,
    CustomCurrencyPipe,  // Export it so it can be used in other modules
    FujiBillingSidebarComponent,
    FujiBillingFooterComponent,
    ArabicDigitsPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    TranslateModule,
    MatCheckboxModule,
    MatTooltipModule
  ],

})
export class SharedModule { }
